// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-popover.sidemenu-popover::part(content) {
  top: 70px !important;
  left: unset !important;
  right: 15px !important;
  border-radius: 0 !important;
}

ion-popover.secondary-sidemenu-popover::part(content) {
  top: 70px !important;
  right: unset !important;
  left: 15px !important;
  border-radius: 0 !important;
}

.sidemenu-popover {
  --height: 1000px;
  --min-width: 320px;
}

.navbar-button {
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/app/components/site-header/site-header.component.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;EACA,sBAAA;EACA,sBAAA;EACA,2BAAA;AACJ;;AAEA;EACI,oBAAA;EACA,uBAAA;EACA,qBAAA;EACA,2BAAA;AACJ;;AAEA;EACI,gBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,iBAAA;AACJ","sourcesContent":["ion-popover.sidemenu-popover::part(content){\r\n    top: 70px !important;\r\n    left: unset!important;\r\n    right: 15px!important;\r\n    border-radius: 0!important;\r\n}\r\n\r\nion-popover.secondary-sidemenu-popover::part(content){\r\n    top: 70px !important;\r\n    right: unset!important;\r\n    left: 15px!important;\r\n    border-radius: 0!important;\r\n}\r\n\r\n.sidemenu-popover{\r\n    --height: 1000px;\r\n    --min-width: 320px;\r\n}\r\n\r\n.navbar-button{\r\n    font-weight: bold;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
